module.exports = __webpack_public_path__ + "img/react.50dd5fdc.jpg";